import { forwardRef, type ComponentProps } from "react";
import { cn } from "@/lib/utils";

type FloatingFieldProps = Omit<ComponentProps<"input">, "placeholder"> & {
  id: string;
  label: string;
  error?: string;
};

export const FloatingField = forwardRef<HTMLInputElement, FloatingFieldProps>(
  function FloatingField({ id, label, error, className, ...props }, ref) {
    const errorId = `${id}-error`;

    return (
      <div>
        <div className="relative">
          <input
            {...props}
            ref={ref}
            id={id}
            placeholder=" "
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? errorId : undefined}
            className={cn("home-float-input", className)}
          />
          <label htmlFor={id} className="home-float-label">
            {label} *
          </label>
        </div>
        {error ? (
          <p id={errorId} className="mt-1.5 text-[14px] leading-snug text-home-error">
            {error}
          </p>
        ) : null}
      </div>
    );
  },
);
